import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import { DepositResult } from '../../../api/web3/deposit-api'
import { Token } from '../../../logic/token/token'
import { Wei } from '../../../utils/types'
import { MultiDepositPreview } from './MultiDepositPreview'
import { CheckCircle } from '../../catalog/icons/CheckCircle'
import { EmptyLine } from '../../catalog/EmptyLine'
import { PVProductionInformation } from '../../swap/preswap/PreSwapPopup'
import { addToWallet } from '../../../api/web3/metamask-api'
import metamask from '../../../assets/images/metamask.svg'
import { AddToButton } from '../../swap/preswap/PostSwapPopup'
import {
  isCoinbaseInjected,
  isMetamaskInjected,
  isProbablyBrave,
} from '../../connection/provider'
import { getPoolToken } from '../../../logic/pools/Pool'
import { Web3Context } from '../../../hooks/web3'

const DepositPostviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export interface Props {
  deposit: DepositResult
  amounts: Map<Token, Wei>
  residues?: Token[]
}

export const DepositPostview: FC<Props> = ({ deposit, amounts, residues }) => {
  const showAddToMetamask =
    !!window.ethereum && !isCoinbaseInjected() && !isProbablyBrave()
  isMetamaskInjected()
  const showAddToWallet =
    !!window.ethereum &&
    (!isMetamaskInjected() || isProbablyBrave()) &&
    !isCoinbaseInjected()

  const pool = deposit.pool
  const token = getPoolToken(pool)
  const {
    web3,
    config: { getExplorerUrl },
  } = useContext(Web3Context)

  const txUrl = getExplorerUrl(deposit.hash)
  return (
    <DepositPostviewWrapper className={'pt10'}>
      <div className={'align-center text-center'}>
        <span className={'light'} style={{ paddingRight: '5px' }} data-cy={'confirmed'}>
          Confirmed
        </span>
        <CheckCircle />
      </div>
      <MultiDepositPreview
        amounts={amounts}
        pool={deposit.pool}
        expectedShare={deposit.value}
      />

      {residues /*&& residues.size>0*/ && (
        <div>
          <EmptyLine />
          <PVProductionInformation>
            <div style={{ textAlign: 'left' }}>
              All residual amounts from the{' '}
              <span className={'numeric'}>0x Protocol</span> intermediary swaps
              which were not used to join the pool have been sent to your
              address.
            </div>
          </PVProductionInformation>
        </div>
      )}

      {/* TODO : Add the right token logo */}
      {showAddToMetamask && (
        <>
          <EmptyLine />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <AddToButton onClick={() => addToWallet(web3!, token, false)}>
              <img src={metamask} /> <span>Add {token.symbol} to metamask</span>
            </AddToButton>
          </div>
        </>
      )}
      {/* TODO : Add the right token logo */}
      {showAddToWallet && (
        <>
          <EmptyLine />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <AddToButton onClick={() => addToWallet(web3!, token, false)}>
              <span>Add {token.symbol} to wallet</span>
            </AddToButton>
          </div>
        </>
      )}
      <div className={'align-center text-center'}>
        <EmptyLine />
        <a href={txUrl} className={'link pt20 small-text'} target={'_blank'}>
          Transaction on explorer
        </a>
      </div>
    </DepositPostviewWrapper>
  )
}
